import React from 'react';
import './index.css';

import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Layout from './layouts/Layout';


import { Home,About,Contact,Register,ResetPassword,Ressource,MaketPlace,Forum,ForgotPassword,Login,Blog,Calendar,Profil,Trainning ,Chat, Catalog} from "./pages";
import DefaultLayout from './layouts/default.layout';


const App = () => {
  return (

    <Router>

      <Routes>

        {/* routes authentifiees */}
        {/* <Route  element={<Layout />}>
          <Route path="/" element={<Home />}   />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/ressource" element={<Ressource />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/forum" element={<Forum />} />
          <Route path="/maket-place" element={<MaketPlace />} />
          <Route path="/profil" element={<Profil />} />
          <Route path="/trainning" element={<Trainning />} />
          <Route path="/catalog" element={<Catalog />} />
        </Route> */}

        {/* routes non authentifiees */}
        
        <Route path='/' element={<DefaultLayout />} >
          <Route path="" element={<Home />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>
    </Router>

  );
};

export default App;
